import React, { useEffect, useState } from "react";
import { Button, Select, Descriptions, Spin, Popconfirm } from "antd";
import AuthService from "../../Components/auth/AuthService";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import Message from "../../Components/common/Message";
import "./dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import {
  allPumpTrucks,
  cardTerminals,
  pumpTruckBatteries,
  schedules,
  trollies,
  vehicleTypes,
} from "../../Components/common/Constants";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import { getCurrentLocation } from "../../Components/Utils/geolocation";
const Auth = new AuthService();
const useStyles = makeStyles((theme) => ({
  antlabel: {
    "& .ant-form-item-label > label": {
      fontSize: "18px",
      fontWeight: 700,
    },
  },
  dataSheet: {
    "& .ant-select-outlined.ant-select-disabled .ant-select-selector": {
      fontWeight: 500,
      background: "none",
      color: "black"
    },
    "& .ant-select-outlined.ant-select-multiple .ant-select-selection-item": {
      fontWeight: 500,
      // background: "none",
      color: "black"
    },
  },
}));

const Dashboard = () => { // wait
  const { pinValidity } = useSelector((state) => state.AppState.driverData);
  const { reportSubmit } = useSelector((state) => state.AppState.driverData);
  const selectedRouteOrg = useSelector((state) => state.AppState.driverData.selectedRoute);
  const driverRoutesRedux = useSelector((state) => state.AppState.driverData.driverRoutes);
  const mySelectedRoute = useSelector((state) => state?.AppState?.driverData?.selectedRoute);
  const navigate = useNavigate();
  const classes = useStyles();
  const { Option } = Select;
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const securityPinExists = localStorage.getItem("securityPin");

  const [isLoading, setIsLoading] = useState(false);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [driverRoutes, setDriverRoutes] = React.useState([]);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [selectedHelper, setSelectedHelper] = useState("");
  const [selectedHelperNumber, setSelectedHelperNumber] = useState("");
  const [selectedVehicleType, setSelectedVehicleType] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [terminalNo, setTerminalNo] = useState("");
  const [pbNumber, setPbNumber] = useState("");
  const [pumpTruckNo, setPumpTruckNo] = useState("");
  const [trolleyNo, setTrolleyNo] = useState([]);
  const [noData, setNoData] = useState(false);
  const [routeStatus, setRouteStatus] = useState("");


  const handleStartRoute = async () => {
    localStorage.setItem("read_only", false);
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }
    if (!terminalNo) {
      setType("error");
      setLoadMessage("Please enter the Credit Card Terminal Number." + str);
      return;
    }

    // if (!pbNumber) {
    //   setType("error");
    //   setLoadMessage("Please Select the Pump Truck Battery." + str);
    //   return;
    // }

    if (!trolleyNo?.length) {
      setType("error");
      setLoadMessage("Please enter the trolley Number." + str);
      return;
    }

    if (pumpTruckNo === undefined || pumpTruckNo === null) {
      setType("error");
      setLoadMessage("Please enter the Pump Truck Number." + str);
      return;
    }

    let finalPbNumber = pbNumber;
    if (pumpTruckNo === -1) {
      finalPbNumber = 0;
    } else if (pumpTruckNo > 0 && !pbNumber) {
      setType("error");
      setLoadMessage("Please select the Pump Truck Battery." + str);
      return;
    }

    setIsLoading(true);
    try {
      const location = await getCurrentLocation();
      const trolley = trolleyNo.toString();
      console.log({ trolley });
      const dataToSend = {
        route_status_id: selectedRoute,
        terminal_id: terminalNo,
        trolly_id: trolley,
        pumptruck_id: pumpTruckNo,
        battery_id: finalPbNumber,
        start_status: 1,
        ...location,
      };
      const response = await Auth.fetch(`/driverapp/start-route`, {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (response.ack) {
        navigate("/report");
        localStorage.setItem('routeLocation', true)
        setIsLoading(false);
      } else {
        setType("error");
        setLoadMessage(response.message);
        setIsLoading(false);
      }
    } catch (err) {
      setType("error");
      setLoadMessage(err.message);
      setIsLoading(false);
    }
  };

  const handleViewRoute = () => {
    localStorage.setItem("read_only", true);
    dispatch({ type: 'SUBMIT_REPORT', payload: { route_id: mySelectedRoute, status: true } })
    navigate("/routes");
  };

  const handleChange = (value) => {
    console.log(value)
    console.log(driverRoutes)
    const selectedRouteData = driverRoutes.find((route) => route.id === value);
    console.log('selectedRouteData', selectedRouteData)
    if (selectedRouteData) {
      setSelectedRoute(value);
      setRouteStatus(selectedRouteData?.start_status);
      dispatch({ type: "SELECTED_ROUTE", payload: value });
      setSelectedVehicle(selectedRouteData.vehicle);
      setSelectedHelper(selectedRouteData.helper_name);
      setSelectedHelperNumber(selectedRouteData.helper_number);
      dispatch({
        type: "SELECTED_ROUTE_NAME",
        payload: selectedRouteData.route,
      });
      localStorage.setItem("route_name", selectedRouteData.route);
      localStorage.setItem("driver_id", selectedRouteData.driver_id);
      localStorage.setItem("DriverName", selectedRouteData.driver_name);
      setSelectedVehicleType(selectedRouteData.vehicle_type);
      setScheduleTime(selectedRouteData.schedule_id);
      setTerminalNo(selectedRouteData.terminal_id);
      setPbNumber(selectedRouteData.battery_id);
      const trolleyIDArray = selectedRouteData.trolly_id
        ?.split(",")
        .map(Number);
      setTrolleyNo(trolleyIDArray);
      setPumpTruckNo(selectedRouteData.pumptruck_id);
    }
  };


  const items = [
    {
      label: (
        <span>
          Route
          <span style={{ color: "red", fontSize: "20px" }}>*</span>
        </span>
      ),
      children: (
        <>
          {driverRoutes?.length > 0 && (
            <Select
              defaultValue={driverRoutes.length === 1 ? driverRoutes[0]?.id : null}
              style={{
                width: "100%",
              }}
              onChange={handleChange}
              placeholder="Select route to proceed "
            >
              {driverRoutes.map((item) => (
                <Select.Option
                  // disabled={item.start_status === 2}
                  key={item.id}
                  value={item.id}
                >
                  {item.start_status === 2
                    ? item.route + " (Completed)"
                    : item.route}
                </Select.Option>
              ))}
            </Select>
          )}
        </>
      ),
    },
  ];

  const ConditionalItems = [
    {
      label: <span>Truck No.</span>,
      // span: 4,
      children: (
        <span>
          {selectedVehicle +
            ` (${selectedVehicleType
              ? vehicleTypes.filter((obj) => obj.id == selectedVehicleType)[0]
                .title
              : ""
            })`}
        </span>
      ),
    },
    {
      label: "Helper",
      // span: 3,
      children: <span>{selectedHelper || ""}</span>,
    },
    {
      label: "Schedule Time",
      // span: 3,
      children: (
        <span>
          {scheduleTime
            ? schedules.filter((obj) => obj.id == scheduleTime)[0].title
            : ""}
        </span>
      ),
    },
    {
      label: (
        <span>
          Credit Card Terminal No.
          <span style={{ color: "red", fontSize: "20px" }}>*</span>
        </span>
      ),
      // span: 3,
      children: (
        <>
          <Select
            style={{
              width: "100%",
            }}
            value={terminalNo}
            placeholder="Select terminal"
            onChange={(value) => {
              setTerminalNo(value);
            }}
            disabled={routeStatus === 2}
          >
            {cardTerminals.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </>
      ),
    },
    {
      label: (
        <span>
          Trolley
          <span style={{ color: "red", fontSize: "20px" }}>*</span>
        </span>
      ),
      // span: 3,
      children: (
        <>
          <Select
            mode="multiple"
            style={{
              width: "100%",
            }}
            value={trolleyNo}
            showSearch={false}
            disabled={routeStatus === 2}
            placeholder="Select Trolley"
            onChange={(value) => {
              setTrolleyNo(value);
            }}
          >
            {trollies.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </>
      ),
    },
    {
      label: (
        <span>
          Pump Truck
          <span style={{ color: "red", fontSize: "20px" }}>*</span>
        </span>
      ),
      // span: 3,
      children: (
        <>
          <Select
            style={{
              width: "100%",
            }}
            value={pumpTruckNo}
            placeholder="Select Pump truck"
            onChange={(value) => {
              setPumpTruckNo(value);
            }}
            disabled={routeStatus === 2}
          >
            {allPumpTrucks.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </>
      ),
    },
    ...(pumpTruckNo > 0
      ? [
        {
          label: (
            <span>
              Pump Truck Battery
              <span style={{ color: "red", fontSize: "20px" }}>*</span>
            </span>
          ),
          children: (
            <Select
              style={{
                width: "100%",
              }}
              value={pbNumber}
              placeholder="Select Pump Truck Battery"
              onChange={(value) => {
                setPbNumber(value);
              }}
              disabled={routeStatus === 2}
            >
              {pumpTruckBatteries.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>
          ),
        },
      ]
      : []),
    // {
    //   label: (
    //     <span>
    //       Pump Truck Battery
    //       <span style={{ color: "red", fontSize: "20px" }}>*</span>
    //     </span>
    //   ),
    //   // span: 3,
    //   children: (
    //     <>
    //       <Select
    //         style={{
    //           width: "100%",
    //         }}
    //         value={pbNumber}
    //         placeholder="Select Pump Truck Battery"
    //         onChange={(value) => {
    //           setPbNumber(value);
    //         }}
    //         disabled={routeStatus === 2}
    //       >
    //         {pumpTruckBatteries.map((item) => (
    //           <Option key={item.id} value={item.id}>
    //             {item.title}
    //           </Option>
    //         ))}
    //       </Select>
    //     </>
    //   ),
    // },
  ];

  const onFinish = async () => {
    const pin = localStorage.getItem("securityPin");
    const delivery = localStorage.getItem("delivery_date");
    const expirationDate = moment().add(1, "days").format("YYYY-MM-DD");
    const dataToSend = {
      pin: pin,
      delivery_date: delivery,
      // delivery_date: moment(new Date(DatePicker)).format('YYYY-MM-DD'),
    };
    setLoadMessage("");
    setIsLoading(true);
    try {
      const response = await Auth.fetch(`/driverapp/pin`, {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (response?.ack) {
        // dispatch({ type: "SET_ROUTES", payload: response.driver_routes });
        const sortedArray = response?.driver_routes?.sort((a, b) => {
          if (a.start_status === 1 && b.start_status === 2) {
            return -1;
          } else if (a.start_status === 2 && b.start_status === 1) {
            return 1;
          } else {
            return 0;
          }
        });
        setDriverRoutes(sortedArray);
        const driverId = sortedArray[0].driver_id;
        const vehicleId = sortedArray[0].vehicle_id;
        localStorage.setItem("accident_driver_id", driverId);
        localStorage.setItem("accident_vehicle_id", vehicleId);
        dispatch({ type: "SET_ROUTES", payload: sortedArray });
        localStorage.setItem("route_name", "");
        localStorage.setItem("DriverName", "");
        if (sortedArray.length === 1) {
          console.log('here')
          // handleChange(sortedArray[0].id);
          const selectedRouteData = sortedArray.find((route) => route.id === sortedArray[0].id);
          console.log('selectedRouteData', selectedRouteData)
          if (selectedRouteData) {
            setSelectedRoute(sortedArray[0].id);
            setRouteStatus(selectedRouteData.start_status);
            dispatch({ type: "SELECTED_ROUTE", payload: sortedArray[0].id });
            setSelectedVehicle(selectedRouteData.vehicle);
            setSelectedHelper(selectedRouteData.helper_name);
            setSelectedHelperNumber(selectedRouteData.helper_number);
            dispatch({
              type: "SELECTED_ROUTE_NAME",
              payload: selectedRouteData.route,
            });
            localStorage.setItem("route_name", selectedRouteData.route);
            localStorage.setItem("driver_id", selectedRouteData.driver_id);
            localStorage.setItem("DriverName", selectedRouteData.driver_name);
            setSelectedVehicleType(selectedRouteData.vehicle_type);
            setScheduleTime(selectedRouteData.schedule_id);
            setTerminalNo(selectedRouteData.terminal_id);
            setPbNumber(selectedRouteData.battery_id);
            const trolleyIDArray = selectedRouteData.trolly_id
              ?.split(",")
              .map(Number);
            setTrolleyNo(trolleyIDArray);
            setPumpTruckNo(selectedRouteData.pumptruck_id);

            // let checkSubmit = reportSubmit.find((rs) => rs.route_id === selectedRoute);
            // if (checkSubmit?.status) {
            //   navigate("/routes")
            // }
            let checkSubmit = reportSubmit.find((rs) => rs.route_id === selectedRouteOrg);
            if (checkSubmit?.status) {
              navigate("/routes")
            }
          }
        }
        if (sortedArray.length > 1) {
          console.log('here l')
          handleChange(sortedArray[0].id);
          const selectedRouteData = sortedArray.find((route) => route.id === selectedRouteOrg);
          console.log('selectedRouteData', selectedRouteData)
          if (selectedRouteData) {
            setSelectedRoute(selectedRouteOrg);
            setRouteStatus(selectedRouteData.start_status);
            dispatch({ type: "SELECTED_ROUTE", payload: selectedRouteOrg });
            setSelectedVehicle(selectedRouteData.vehicle);
            setSelectedHelper(selectedRouteData.helper_name);
            setSelectedHelperNumber(selectedRouteData.helper_number);
            dispatch({
              type: "SELECTED_ROUTE_NAME",
              payload: selectedRouteData.route,
            });
            localStorage.setItem("route_name", selectedRouteData.route);
            localStorage.setItem("driver_id", selectedRouteData.driver_id);
            localStorage.setItem("DriverName", selectedRouteData.driver_name);
            setSelectedVehicleType(selectedRouteData.vehicle_type);
            setScheduleTime(selectedRouteData.schedule_id);
            setTerminalNo(selectedRouteData.terminal_id);
            setPbNumber(selectedRouteData.battery_id);
            const trolleyIDArray = selectedRouteData.trolly_id
              ?.split(",")
              .map(Number);
            setTrolleyNo(trolleyIDArray);
            setPumpTruckNo(selectedRouteData.pumptruck_id);
            let checkSubmit = reportSubmit.find((rs) => rs.route_id === selectedRouteOrg);
            if (checkSubmit?.status) {
              navigate("/routes")
            }

          }

        }
        // let checkSubmit = reportSubmit.find((rs) => rs.route_id === selectedRouteOrg);
        // if (checkSubmit?.status) {
        //   navigate("/routes")
        // }
        setIsLoading(false);
      } else {
        setType("error");
        setLoadMessage(response.message);
        setIsLoading(false);
        console.log('herehere');

        setTimeout(() => {
          navigate("/pin")
          dispatch({ type: "RESET_STATE" });
          localStorage.removeItem("DriverName");
          localStorage.removeItem("securityPin");
          localStorage.removeItem("driverRoutes");
          localStorage.setItem('routeLocation', false)
        }, 2000);

      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false);
    }
  };

  if (!pinValidity) {
    console.log('here1');
    localStorage.removeItem("DriverName");
    localStorage.removeItem("securityPin");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    navigate("/pin");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  if (!securityPinExists) {
    console.log('here2');
    navigate("/pin");
    localStorage.removeItem("DriverName");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  useEffect(() => {
    onFinish();
  }, []);


  return (
    <div className={classes.dataSheet}>
      {isLoading ? (
        <Spin style={{ display: "block" }} />
      ) : (
        <>
          <>
            <div className="box-content">
              {isSmallScreen ? (
                <Descriptions
                  title="Select Route"
                  layout="vertical"
                  bordered
                  items={items}
                />
              ) : (
                <Descriptions title="Select Route" style={{ marginBottom: "5px" }} bordered size={"small"}>
                  {items.map((item, index) => (
                    <Descriptions.Item
                      key={index}
                      label={item.label}
                      labelStyle={{ width: "220px", fontWeight: 500 }}
                    >
                      {item?.children}
                    </Descriptions.Item>
                  ))}
                </Descriptions>
                // <Descriptions title="Select Route" bordered items={items} />
              )}

              {selectedRoute && (
                <>
                  {isSmallScreen ? (
                    <Descriptions
                      title="Route Details"
                      layout="vertical"
                      bordered
                      items={ConditionalItems}
                    />
                  ) : (
                    <Descriptions title="Route Details" labelStyle={{ width: '220px', fontWeight: 500 }} column={1} style={{ marginBottom: "5px" }} bordered size={"small"}>
                      {ConditionalItems.map((item, index) => (
                        <Descriptions.Item
                          key={index}
                          label={item.label}
                        >
                          {item?.children}
                        </Descriptions.Item>
                      ))}
                    </Descriptions>
                    // <Descriptions
                    //   title="Route Details"
                    //   bordered
                    //   items={ConditionalItems}
                    // />
                  )}
                </>
              )}
            </div>
            {selectedRoute && (
              <div className="box-button" style={{ marginTop: "15px" }}>
                {routeStatus <= 1 ? (
                  <>
                    <Button
                      style={{
                        height: "40px",
                        width: "150px",
                        padding: "4px",
                        fontSize: "15px",
                        marginRight: '10px'
                      }}
                      size="large"
                      type="primary"
                      loading={isLoading}
                      onClick={handleStartRoute}
                    >
                      Start Route
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      style={{
                        height: "40px",
                        width: "150px",
                        padding: "4px",
                        fontSize: "15px",
                        marginRight: '10px'
                      }}
                      size="large"
                      type="primary"
                      onClick={handleViewRoute}
                    >
                      View Route
                    </Button>
                  </>
                )}
              </div>
            )}
          </>
        </>
      )}

      <Message type={type} msg={loadMessage} />
    </div>
  );
};

export default Dashboard;
